// extracted by mini-css-extract-plugin
export default {"wrapper":"Ft-z","response":"Gt-z","error":"Ht-z","disabled":"It-z","buttons":"Jt-z","feedbackQuestionSection":"Kt-z","yesNoWrapper":"Lt-z"};